/**
 * 企业微信相关配置常量
 * 参考文档：
 * - 网页授权登录：https://developer.work.weixin.qq.com/document/path/91335
 * - 获取访问令牌：https://developer.work.weixin.qq.com/document/path/91039
 * - 获取用户信息：https://developer.work.weixin.qq.com/document/path/91023
 * - 获取部门成员：https://developer.work.weixin.qq.com/document/path/90196
 */

import { getApiBaseUrl } from '@/utils/apiBase';

// 企业微信应用配置
export const WECOM_CONFIG = {
    // 企业微信应用配置（从环境变量获取）
    CORP_ID: process.env.VUE_APP_WECOM_CORP_ID || '', // 企业ID
    AGENT_ID: process.env.VUE_APP_WECOM_AGENT_ID || '', // 应用ID
    SECRET: process.env.VUE_APP_WECOM_SECRET || '', // 应用Secret

    // 网页授权配置
    REDIRECT_URI: process.env.VUE_APP_WECOM_REDIRECT_URI || '', // 授权后重定向的回调链接地址（默认值）
    STATE: 'wecom_auth', // 重定向后会带上state参数

    // 授权类型
    AUTH_TYPE: {
        SNSSCOPE_BASE: 'snsapi_base', // 静默授权，只能获取用户的openid
        SNSSCOPE_USERINFO: 'snsapi_userinfo' // 手动授权，可以获取用户的基本信息
    },

    // 授权URL
    AUTH_URL: 'https://open.weixin.qq.com/connect/oauth2/authorize',

    // API基础URL
    API_BASE_URL: 'https://qyapi.weixin.qq.com/cgi-bin',

    // 后端API基础URL
    BACKEND_API_BASE_URL: getApiBaseUrl(),

    // 授权说明
    AUTH_DESCRIPTION: {
        SNSSCOPE_BASE: '静默授权：用户无需手动确认，只能获取用户的openid和userid',
        SNSSCOPE_USERINFO: '手动授权：需要用户手动确认，可以获取用户的基本信息'
    }
};

// 企业微信API接口
export const WECOM_API = {
    // 获取访问令牌
    GET_ACCESS_TOKEN: '/gettoken',

    // 网页授权相关
    GET_USER_INFO: '/auth/getuserinfo', // 获取访问用户身份
    GET_USER_DETAIL: '/user/get', // 获取部门成员详情

    // 通讯录管理
    GET_DEPARTMENT_LIST: '/department/list', // 获取部门列表
    GET_DEPARTMENT_USER_LIST: '/user/list', // 获取部门成员列表
    GET_USER_SIMPLE_LIST: '/user/simplelist' // 获取部门成员
};

// 后端API接口
export const BACKEND_API = {
    // 企业微信相关
    WECOM_ACCESS_TOKEN: '/wecom/access-token', // 获取企业微信access_token
    WECOM_USER_INFO: '/wecom/user-info', // 通过code获取用户信息
    WECOM_USER_DETAIL: '/wecom/user-detail' // 获取用户详细信息
};

// 企业微信错误码
export const WECOM_ERROR_CODES = {
    SUCCESS: 0, // 成功
    INVALID_ACCESS_TOKEN: 40014, // access_token无效
    ACCESS_TOKEN_EXPIRED: 42001, // access_token超时
    INVALID_CODE: 40029, // code无效
    FREQUENCY_LIMIT: 45009, // 接口调用频率超限
    NO_PERMISSION: 60011, // 无权限访问用户信息
    USER_NOT_EXIST: 60111 // 用户不存在
};

// 企业微信环境检测
export const WECOM_ENV = {
    // 检测是否在企业微信环境中
    isInWecom () {
        return /wxwork/.test(navigator.userAgent.toLowerCase());
    },

    // 检测是否在微信环境中
    isInWechat () {
        return /micromessenger/.test(navigator.userAgent.toLowerCase());
    },

    // 检测是否在移动端
    isMobile () {
        return /mobile|android|iphone|ipad|phone/i.test(navigator.userAgent.toLowerCase());
    }
};

// 动态生成重定向URI
export const getRedirectUri = (loginEntry = 'frontend') => {
    const baseUrl = window.location.origin + window.location.pathname;

    if (loginEntry === 'admin') {
        // 管理后台登录，重定向到admin-login页面
        return `${baseUrl}#/admin-login`;
    } else {
        // 前台登录，重定向到login页面
        return `${baseUrl}#/login`;
    }
};
